export var $error = {
  error: {
    status: null,
    statusText: null,
    messages: null
  }
}

export function handleResponse(response) {
  if (!response.ok) {
    const contentType = response.headers.get("content-type")
    if (contentType && contentType.indexOf("application/json") !== -1) {
      return response.json().then(json => {
        throw { status: response.status, statusText: response.statusText, messages: (json.errors ? json.errors : [{ error: json.error }]) }
      })
    } else {
      return response.text().then(text => {
        throw { status: response.status, statusText: response.statusText, messages: [{ error: text }] }
      })
    }
  } else {
    return response;
  }
}

export function handleError(error) {
  console.log(error)
  $error.error.status = error.status ? error.status : -1
  $error.error.statusText = error.statusText ? error.statusText : null
  $error.error.messages = error.messages ? error.messages : (error.message ? [{ error: error.message }] : [{ error: "UNKNOWN_ERROR" }])
  throw error
}
